import estilos from '../Documentacion.module.css'
import React, { Fragment, useState } from 'react'
import { Formik, Form, Field, ErrorMessage } from 'formik';
import BotonSemaforoComponent from '../BotonesComponent/BotonSemaforoComponent';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import NoteAddIcon from '@mui/icons-material/NoteAdd';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import { Portal, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux'
import { ObtenerInformacionCliente, actualizarConstanciaFC11, generarConstanciaFC11 } from '../../../../../../../redux/DuckOrganismoCertificacion/SolicitudesFC01_OCDuck';
import { actualizarLoadingApp_false, actualizarLoadingApp_true } from '../../../../../../../redux/AppDucks';

const styleForm = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '70%', height: '90%',
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
  'overflowY': 'scroll',
};

const styleModalConfirmacion = {
  position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)',
  width: 500, bgcolor: 'background.paper', border: '2px solid #000', boxShadow: 24,
  p: 4, fontSize: '20px', textAlign: 'center'
};

const RevisionEvaluacionDecisionComponent = () => {

  const dispatch = useDispatch()
  const informacionCliente = useSelector(store => store.SolicitudesFC01_OC.informacionCliente)
  const [checkboxValues, setCheckboxValues] = useState({
    apartado1: "v", apartado2: "v", apartado3: "v", apartado4: "v", apartado5: "v", apartado6: "v",
    apartado7: "v", apartado8: "v", apartado9: "v", apartado10: "v", apartado11: "v", apartado12: 'v'
  });

  const handleCheckboxChange = (label, value) => {
    setCheckboxValues((prevValues) => ({
      ...prevValues,
      [label]: value,
    }));
  };

  const [openModal, setOpenModal] = React.useState(false);
  const handleCloseModal = () => {
    setOpenModal(false);
  }
  const modalFormulario = () => {
    return (
      <div>
        <Modal
          open={openModal}
          onClose={handleCloseModal}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={styleForm}>
            <Typography id="modal-modal-title" variant="h6" component="h2">
              <div style={{ textAlign: "center" }}> Certificado NOM </div>
            </Typography>
            <Typography id="modal-modal-description" component="h2" sx={{ mt: 2 }}>
              <div className='container'>
                <div className='container'>
                  <div className='row'>
                    <div className={`text-center mb-4 ${estilos.titulo}`}><strong>REVISIÓN DE LA EVALUACIÓN DE DECISIÓN DE LA CERTIFICACIÓN </strong></div>
                    <Formik
                      initialValues={{
                        fechaRevision: '',
                        noDeSolicitud: '',
                        tipoCertificado: '',
                        noCertificado: '',
                        criterio: '',
                        fechaVigencia: '',
                        fechaVencimiento: '',
                        producto:'',
                        categoria:'',
                      }}
                      enableReinitialize={true}
                      validate={values => {
                        const errors = {};
                        if (!values.fechaRevision) {
                          errors.fechaRevision = 'Requerido!';
                        }
                        if (!values.fechaVigencia) {
                          errors.fechaVigencia = 'Requerido!';
                        }
                        if (!values.fechaVencimiento) {
                          errors.fechaVencimiento = 'Requerido!';
                        }
                        if (!values.noCertificado) {
                          errors.noCertificado = 'Requerido!';
                        }
                        return errors;
                      }}
                      onSubmit={(values, { setSubmitting }) => {
                        handleOpenConfirmar(values)
                        setSubmitting(false);
                      }}

                    >

                      <Form>
                        <div className={`container ${estilos.contenedorForm}`}>
                          <div className='row'>
                            <div className='col-12 col-xs-12 col-md-6 col-lg-6 col-xl-6'>
                              <label htmlFor="fechaRevision">Fecha de Revisión:</label><br />
                            </div>
                            <div className='col-12 col-xs-12 col-md-6 col-lg-6 col-xl-6'>
                              <Field type="date" className="form-control" id="fechaRevision" name="fechaRevision" />
                              <ErrorMessage name="fechaRevision" component="div" className={`${estilos.error}`} /><br />
                            </div>
                            <div className='col-12 col-xs-12 col-md-6 col-lg-6 col-xl-6'>
                              <label htmlFor="noDeSolicitud">Número de Solicitud:</label><br />
                            </div>
                            <div className='col-12 col-xs-12 col-md-6 col-lg-6 col-xl-6'>
                              <Field type="text" className="form-control" id="noDeSolicitud" name="noDeSolicitud" />
                              <ErrorMessage name="noDeSolicitud" component="div" className={`${estilos.error}`} /><br />
                            </div>
                            {/*<div className='col-12 col-xs-12 col-md-6 col-lg-6 col-xl-6'>
                              <label htmlFor="noCliente">Numero de Cliente:</label><br />
                            </div>
                            <div className='col-12 col-xs-12 col-md-6 col-lg-6 col-xl-6'>
                              <Field type="text" className="form-control" id="noCliente" name="noCliente" />
                              <ErrorMessage name="noCliente" component="div" className={`${estilos.error}`} /><br />
                            </div>*/}
                            <hr>
                            </hr>
                            {/*<div className='col-12 col-xs-12 col-md-6 col-lg-6 col-xl-6'>
                              <label htmlFor="tipoCertificado">Tipo de Certificado Nom Solicitado:</label><br />
                            </div>
                            <div className='col-12 col-xs-12 col-md-6 col-lg-6 col-xl-6'>
                              <Field as="select" name="tipoCertificado" className='form-control'>
                                <option key='0' value='default'>Seleccione una opción</option>
                                <option value='CERTIFICADO DE PRODUCTOR'>CERTIFICADO DE PRODUCTOR</option>
                              </Field>
                              <ErrorMessage name="tipoCertificado" component="div" className={`${estilos.error}`} /><br />
                            </div>*/}
                            <div className='col-12 col-xs-12 col-md-6 col-lg-6 col-xl-6'>
                              <label htmlFor="tipoCertificado">Tipo de Certificado Nom Solicitado:</label><br />
                            </div>
                            <div className='col-12 col-xs-12 col-md-6 col-lg-6 col-xl-6'>
                              <Field type="text" className="form-control" id="tipoCertificado" name="tipoCertificado" />
                              <ErrorMessage name="tipoCertificado" component="div" className={`${estilos.error}`} /><br />
                            </div>
                            <div className='col-12 col-xs-12 col-md-6 col-lg-6 col-xl-6'>
                              <label htmlFor="producto">Producto:</label><br />
                            </div>
                            <div className='col-12 col-xs-12 col-md-6 col-lg-6 col-xl-6'>
                              <Field type="text" className="form-control" id="producto" name="producto" />
                              <ErrorMessage name="producto" component="div" className={`${estilos.error}`} /><br />
                            </div>
                            <div className='col-12 col-xs-12 col-md-6 col-lg-6 col-xl-6'>
                              <label htmlFor="categoria">Categoria:</label><br />
                            </div>
                            <div className='col-12 col-xs-12 col-md-6 col-lg-6 col-xl-6'>
                              <Field type="text" className="form-control" id="categoria" name="categoria" />
                              <ErrorMessage name="categoria" component="div" className={`${estilos.error}`} /><br />
                            </div>
                          </div><hr />
                          <div className={`text-center mb-4 ${estilos.titulo}`}><strong>DECISIÓN DE LA CERTIFICACIÓN </strong></div>

                          <table className='table'>
                            <div style={{ textAlign: 'center !important' }}>
                              <strong>NOM-070-SCFI-2016. BEBIDAS ALCOHOLICAS-MEZCAL-ESPECIFICACIONES EN VIGOR</strong>
                            </div>
                            <tbody>
                              <tr>
                                <td>Apartado</td>
                                <td>Cumplimiento</td>
                              </tr>
                              <tr>
                                <td>4.- Especificaciones</td>
                                <td>
                                  <BotonSemaforoComponent defaultValue="v" label="apartado1" onChange={handleCheckboxChange} />
                                </td>
                              </tr>
                              <tr>
                                <td>4.1. Material prima ara la elaboración de mezcal</td>
                                <td>
                                  <BotonSemaforoComponent defaultValue="v" label="apartado2" onChange={handleCheckboxChange} />
                                </td>
                              </tr>
                              <tr>
                                <td>4.2. Categorías</td>
                                <td>
                                  <BotonSemaforoComponent defaultValue="v" label="apartado3" onChange={handleCheckboxChange} />
                                </td>
                              </tr>
                              <tr>
                                <td>4.3. Especificaciones fisicoquímicas </td>
                                <td>
                                  <BotonSemaforoComponent defaultValue="v" label="apartado4" onChange={handleCheckboxChange} />
                                </td>
                              </tr>
                              <tr>
                                <td>4.4. Proceso de elaboración de Mezcal</td>
                                <td>
                                  <BotonSemaforoComponent defaultValue="v" label="apartado5" onChange={handleCheckboxChange} />
                                </td>
                              </tr>
                              <tr>
                                <td>4.5. Clases de Mezcal</td>
                                <td>
                                  <BotonSemaforoComponent defaultValue="v" label="apartado6" onChange={handleCheckboxChange} />
                                </td>
                              </tr>
                              <tr>
                                <td>5. Envasado</td>
                                <td>
                                  <BotonSemaforoComponent defaultValue="v" label="apartado7" onChange={handleCheckboxChange} />
                                </td>
                              </tr>
                              <tr>
                                <td>6.1. Etiquetado para venta nacional</td>
                                <td>
                                  <BotonSemaforoComponent defaultValue="v" label="apartado8" onChange={handleCheckboxChange} />
                                </td>
                              </tr>
                              <tr>
                                <td>6.2. Etiquetado ara exportación</td>
                                <td>
                                  <BotonSemaforoComponent defaultValue="v" label="apartado9" onChange={handleCheckboxChange} />
                                </td>
                              </tr>
                              <tr>
                                <td>7. Comercialización</td>
                                <td>
                                  <BotonSemaforoComponent defaultValue="v" label="apartado10" onChange={handleCheckboxChange} />
                                </td>
                              </tr>
                              <tr>
                                <td>4.2. Evaluación de la conformidad</td>
                                <td>
                                  <BotonSemaforoComponent defaultValue="v" label="apartado11" onChange={handleCheckboxChange} />
                                </td>
                              </tr>
                            </tbody>
                          </table>
                          <hr />
                          <table className='table text-center' style={{ border: '2px solid #000' }}>
                            <tbody>
                              <tr>
                                <td colSpan={12}>SE OTORGA EL CERTIFICADO</td>
                              </tr>
                              <tr>
                                <td colSpan={12}><Field type="text" className="form-control" id="noCertificado" name="noCertificado" placeholder={'Ingrese el numero de certificado'} /></td>
                              </tr>
                              <tr>
                                <td colSpan={6}>CRITERIO GENERAL EN MATERIA DE CERTIFICACIÓN PARA EVALUAR LA NOM-070-SCFI-2016 "BEBIDAS ALCOHOLICAS-MEZCAL-ESPECIFICACIONES"</td>
                                <td colSpan={6}><Field as="select" name="criterio" className='form-control'>
                                  <option key='0' value='default'>Criterio</option>
                                  <option value='Cumplimiento'>Cumplimiento</option>
                                </Field></td>
                              </tr>
                              <tr>
                                <td colSpan={6}>RELATIVO A LA VIGENCIA DEL CERTIFICADO, APARTADO VII, i) Certificado de Productor</td>
                                <td colSpan={6}> <BotonSemaforoComponent defaultValue="v" label="apartado12" onChange={handleCheckboxChange} /></td>
                              </tr>
                              <tr>
                                <td>FECHA DE INICIO DE VIGENCIA</td>
                                <td>FECHA DE VENCIMIENTO</td>
                              </tr>
                              <tr className='text-center' style={{ textAlign: 'center !important' }}>
                                <td><Field type="date" className="form-control" id="fechaVigencia" name="fechaVigencia" />
                                <ErrorMessage name="fechaVigencia" component="div" className={`${estilos.error}`} /></td>
                                <td><Field type="date" className="form-control" id="fechaVencimiento" name="fechaVencimiento" />
                                <ErrorMessage name="fechaVencimiento" component="div" className={`${estilos.error}`} /></td>
                              </tr>
                            </tbody>
                          </table>
                          <br /><br />
                          <div className='text-center'>
                            <button type="submit" className='btn btn-lg btn-success'> Generar Constancia </button>
                          </div>
                        </div>
                      </Form>
                    </Formik>
                  </div>
                </div>
              </div>
            </Typography>
            <br />

          </Box>
        </Modal>
      </div>
    )
  }

  const [modalConfirmar, setModalConfirmar] = React.useState(false);
  const [valuesForm, setValuesForm] = React.useState(false);
  const handleOpenConfirmar = (values) => {
    setModalConfirmar(true);
    setValuesForm(values)
  }
  const handleCloseConfirmar = () => {
    setModalConfirmar(false);
  }
  const ModalConfirmar = () => {
    return (
      <Modal
        open={modalConfirmar}
        onClose={handleCloseConfirmar}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description">
        <Box sx={styleModalConfirmacion} >
          <h3>Generar Certificado</h3>
          Estás seguro de querer generar este certificado? <br></br>
          <button onClick={() => generarCertificadoCumplimiento()} className='btn btn-danger'>Si, estoy seguro</button>
        </Box>

      </Modal>
    )
  }

  const generarCertificadoCumplimiento = async () => {
    await dispatch(actualizarLoadingApp_true())
    const fecharevision = new Date(valuesForm.fechaRevision)
    const fechaVigencia = new Date(valuesForm.fechaVigencia)
    const fechaVencimiento = new Date(valuesForm.fechaVencimiento)
    if (informacionCliente?.ocsolicitudfc01?.[0]?.ocsolicitudfc01_fc11?.length == 0) {
      const dataCertificado = {
        numerosocio: informacionCliente?.fc_01_solicitudderegistro?.login?.cliente?.[0]?.numerosocio,
        instalaciones: informacionCliente?.fc_01_solicitudderegistro?.login?.cliente?.[0]?.anexocliente,
        checkboxValues: checkboxValues,
        fecharevision: fecharevision.toISOString(),
        numerosolicitud: valuesForm.noDeSolicitud,
        tipocertificado: valuesForm.tipoCertificado,
        producto: valuesForm?.producto,
        categoria: valuesForm?.categoria,
        clase: 'NO APLICA',
        marca: 'NO APLICA',
        tipoMaguey: 'NO APLICA',
        PorcentajeAlcohol: 'NO APLICA',
        numLoteGranel: 'NO APLICA',
        numLoteEnvasado: 'NO APLICA',
        contraseñaNOM: 'NO APLICA',
        hologramas: 'NO APLICA',
        numBotellas: 'NO APLICA',
        presentacion: 'NO APLICA',

        numDictamen: '',
        numAnalisis: 'NO APLICA',
        emitidoPorUno: 'NO APLICA',
        emitidoPorDos: 'NO APLICA',
        emitidoPorTres: 'NO APLICA',

        apartado1: checkboxValues?.apartado1,
        apartado2: checkboxValues?.apartado2,
        apartado3: checkboxValues?.apartado3,
        apartado4: checkboxValues?.apartado4,
        apartado5: checkboxValues?.apartado5,
        apartado6: checkboxValues?.apartado6,
        apartado7: checkboxValues?.apartado7,
        apartado8: checkboxValues?.apartado8,
        apartado9: checkboxValues?.apartado9,
        apartado10: checkboxValues?.apartado10,
        apartado11: checkboxValues?.apartado11,

        noCertificado: valuesForm?.noCertificado,
        criterio: valuesForm?.criterio,
        Cumple: checkboxValues?.apartado12,
        fechaVigencia: fechaVigencia?.toISOString(),
        fechaVencimiento: fechaVencimiento?.toISOString(),

        observaciones: '---',

        idsolicitudesocfc01: informacionCliente?.ocsolicitudfc01?.[0]?.idsolicitudesocfc01,

      }
      await dispatch(generarConstanciaFC11(dataCertificado))
    } else {
      const dataCertificado = {
        numerosocio: informacionCliente?.fc_01_solicitudderegistro?.login?.cliente?.[0]?.numerosocio,
        instalaciones: informacionCliente?.fc_01_solicitudderegistro?.login?.cliente?.[0]?.anexocliente,
        checkboxValues: checkboxValues,
        fecharevision: fecharevision.toISOString(),
        numerosolicitud: valuesForm.noDeSolicitud,
        tipocertificado: valuesForm.tipoCertificado,
        producto: valuesForm?.producto,
        categoria: valuesForm?.categoria,
        clase: 'NO APLICA',
        marca: 'NO APLICA',
        tipoMaguey: 'NO APLICA',
        PorcentajeAlcohol: 'NO APLICA',
        numLoteGranel: 'NO APLICA',
        numLoteEnvasado: 'NO APLICA',
        contraseñaNOM: 'NO APLICA',
        hologramas: 'NO APLICA',
        numBotellas: 'NO APLICA',
        presentacion: 'NO APLICA',

        numDictamen: '',
        numAnalisis: 'NO APLICA',
        emitidoPorUno: 'NO APLICA',
        emitidoPorDos: 'NO APLICA',
        emitidoPorTres: 'NO APLICA',

        apartado1: checkboxValues?.apartado1,
        apartado2: checkboxValues?.apartado2,
        apartado3: checkboxValues?.apartado3,
        apartado4: checkboxValues?.apartado4,
        apartado5: checkboxValues?.apartado5,
        apartado6: checkboxValues?.apartado6,
        apartado7: checkboxValues?.apartado7,
        apartado8: checkboxValues?.apartado8,
        apartado9: checkboxValues?.apartado9,
        apartado10: checkboxValues?.apartado10,
        apartado11: checkboxValues?.apartado11,

        noCertificado: valuesForm?.noCertificado,
        criterio: valuesForm?.criterio,
        Cumple: checkboxValues?.apartado12,
        fechaVigencia: fechaVigencia?.toISOString(),
        fechaVencimiento: fechaVencimiento?.toISOString(),

        observaciones: '--',

        idsolicitudesocfc01: informacionCliente?.ocsolicitudfc01?.[0]?.idsolicitudesocfc01,
        idsolicitudesocfc11: informacionCliente?.ocsolicitudfc01?.[0]?.ocsolicitudfc01_fc11?.[0]?.idsolicitudesocfc11,

      }
      await dispatch(actualizarConstanciaFC11(dataCertificado))
    }
    setModalConfirmar(false);
    setOpenModal(false)
    await dispatch(ObtenerInformacionCliente(informacionCliente?.idsolicitudesuifc01))
    await dispatch(actualizarLoadingApp_false())
  }
  return (
    <Fragment><br />
      <Tooltip title="Nuevo archivo">
        <IconButton size="large" onClick={() => setOpenModal(true)} >
          <NoteAddIcon fontSize="inherit"
            style={informacionCliente?.ocsolicitudfc01?.[0]?.ocsolicitudfc01_fc11?.length > 0 ? { fill: 'green' } : { fill: '#2B2B2B' }} />
        </IconButton>
      </Tooltip>
      {modalFormulario()}
      {ModalConfirmar()}
    </Fragment>
  )
}

export default RevisionEvaluacionDecisionComponent